export default __webpack_public_path__ + "static/media/logo.8da6df2f.png";